import React from 'react'
import type { ReactNode } from 'react'

import { format } from 'date-fns'

interface Props {
  dateHours: Date[]
  children: ReactNode
}

const TicketCalendar: React.FC<Props> = ({ dateHours, children }: Props) => {
  const base = 'ticket-calendar'

  return (
    <div className={base}>
      <div className={`${base}__row--header`}>
        {dateHours.map((dateHour, index) => (
          <div
            key={index}
            className={`${base}__hour-block ${base}__hour-block--header`}
          >
            <span className={`${base}__hour-text`}>
              {format(dateHour, 'HH:mm')}
            </span>
          </div>
        ))}
      </div>
      {children}
    </div>
  )
}

export default TicketCalendar
